import { KrChip } from '@/common/card/KrChip';
import { StringUtils } from '@/common/utils/StringUtils';

// Renders an enum value as a small colored badge, the same way Grid's EnumCellRenderer does; falls back to the
// raw code (or an em dash when blank) if no spec was found for it.
export const EnumChip = ({ enumSpec, code }) => {
  if (!enumSpec) return <>{code ?? '—'}</>;
  return (
    <KrChip label={enumSpec.displayName} icon={enumSpec.icon} color={StringUtils.colorToHexCode(enumSpec.color)} />
  );
};
